import Box from '@mui/material/Box';
import * as React from 'react';

type Props = {
  children: React.ReactNode;
}

export const CenterBox = ({ children }: Props) => {

  return (

  <Box
    sx={{
      flexGrow: 1,
      overflowX: 'hidden',
      width: '100vw',
      display: 'flex',
      justifyContent: 'center',
    }}
  >
    <Box 
      sx={{
        width: '720px',
        padding: '32px'
      }}
    >
      {children}
    </Box>
  </Box>
)};


